<template>
  <v-dialog
    eager
    max-width="450"
    v-model="dialog"
    content-class="dialog-asta-rosa-mobile-dialog"
  >
    <v-card class="dialog-asta-rosa-mobile-card">
      <v-card-title class="secondary white--text dialog-asta-rosa-mobile-title">
        <span class="font-hemi-head">ROSE</span>
        <v-spacer></v-spacer>
        <v-btn icon @click="dismiss">
          <v-icon class="white--text">close</v-icon>
        </v-btn>
      </v-card-title>
      <asta-rose
        v-if="dialog"
        class="navy darken-2 dialog-asta-rosa-mobile-content"
        :show-title="false"
        :show-link-to-plan="false"
      ></asta-rose>
    </v-card>
  </v-dialog>
</template>

<script>
import db from "../../js/db";
import AstaRose from "../AstaRose";

export default {
  name: "dialog-asta-rosa",
  components: {
    AstaRose,
  },
  data() {
    return {
      dialog: false,
    };
  },
  mounted() {
    console.log("--> DialogAstaRosa mounted.");
    db.on("showDialogAstaRosa", this.show);
  },
  destroyed() {
    console.log("<-- DialogAstaRosa destroyed.");
    db.off("showDialogAstaRosa", this.show);
  },
  methods: {
    show() {
      this.dialog = true;
    },
    dismiss() {
      this.dialog = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.dialog-asta-rosa-mobile-card {
  display: flex;
  flex-direction: column;
  max-height: calc(100vh - 48px);
  overflow: hidden;
}
.dialog-asta-rosa-mobile-title {
  flex: 0 0 auto;
}
.dialog-asta-rosa-mobile-content {
  flex: 1 1 auto;
  min-height: 0;
  overflow: auto;
}
</style>
